import React from 'react'

export default function PageLoading() {
  return (
    <div className="page-loading">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Layout/PageLoading.jsx